import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import ReactPlayer from 'react-player'
import { useTranslations } from '../../utils/Text'
import media from '../../utils/media'
import Paragraph from './Paragraph'

const Container = styled.div`
  width: 102vw;
  max-height: 760px;
  overflow: hidden;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-bottom: 29px;
  ${media.mobileL`
    margin-bottom: 40px;
  `}

  .react-player {
    width: 602px !important;
    height: 339px !important;
    margin: 0 auto;
    ${media.mobileL`
      width: 100% !important;
      height: 252px !important;
  `}
  }
`

const Overlay = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-image: url(${props => props.playImg});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  width: 602px !important;
  height: 339px !important;
  margin: 0 auto;
  ${media.mobileL`
      width: 100% !important;
      height: 252px !important;
      background-image: url(${props => props.playImgMobile});
  `}
}
`
const ContentWrapper = styled.div`
  max-width: 790px;
  margin: 0 auto;
  padding: 0 27px;
`

export default function Video({ config }) {
  const {
    youtube,
    optional,
    subtitleLineHeight,
    overlayImg,
    overlayImgMobile,
    videoTitle,
    marginBText,
    padding,
    paddingMobile,
    titleFontSize,
    titleLineHeight,
    videoDescription,
    subtitleFontSize,
    fontFamily,
  } = config

  const youtubeToShow = useTranslations(youtube, { optional })
  const playOverlayToShow = useTranslations(overlayImg, { optional })
  const playOverlayToShowMobile = useTranslations(overlayImgMobile, {
    optional,
  })

  const [isVideoStart, setVideoStart] = useState(false)
  const [showVideo, setShowVideo] = useState(false)
  const [playVideo, setPlayVideo] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.inninnerWidth)

  const updateWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  const handleOverlay = () => {
    setPlayVideo(true)
    setVideoStart(true)
  }

  useEffect(() => {
    updateWidth()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [windowWidth])

  useEffect(() => {
    if (isVideoStart && !showVideo) {
      setTimeout(function() {
        setShowVideo(true)
      }, 300)
    }
  }, [isVideoStart, showVideo])

  return (
    <>
      {youtubeToShow === null ? null : (
        <>
          <Container className="main-cont-video">
            {playVideo === true ? null : (
              <>
                <Overlay
                  showVideo={showVideo}
                  playImg={playOverlayToShow}
                  playImgMobile={playOverlayToShowMobile}
                  onClick={handleOverlay}
                />
              </>
            )}

            <ReactPlayer
              url={youtubeToShow}
              className="react-player"
              playing={playVideo}
              width="100%"
              height="100%"
              controls
            />
          </Container>

          <ContentWrapper>
            <Paragraph
              paragraph={videoTitle}
              marginB={marginBText}
              padding={padding}
              paddingMobile={paddingMobile}
              fontSize={titleFontSize}
              lineHeight={titleLineHeight}
            />
            <Paragraph
              classN="col-12 col-md-10 mx-auto"
              paragraph={videoDescription}
              marginB={marginBText}
              fontSize={subtitleFontSize}
              lineHeight={subtitleLineHeight}
              fontFamily={fontFamily}
            />
          </ContentWrapper>
        </>
      )}
    </>
  )
}
